<template>
 
    <div class="rp-card">
    <div class="rp-card-image-wrapper" :style="{ backgroundImage: `url(${group.image})` }">
   
    </div>
    
    <div class="rp-card-details">
      <h3>{{ group.name }}</h3>
      
      <strong>{{ group.sessionsFormatted }}</strong>    
      <span>{{ group.durationFormatted }}</span>

     
     
      

      
      <div v-if="upcomingHours.length > 0">
        <strong>Najbliższe terminy: </strong>
        <ul>
          <li v-for="hour in upcomingHours" :key="hour.id">
            <span v-html="formatHour(hour)"></span>
            <span v-if="hour.location"><br>{{ hour.location.name }}</span>
          </li>
        </ul>
      </div>
      <div v-else>
        <p>Brak zaplanowanych spotkań.</p>
      </div>
    </div>
    </div>

</template>

<script setup>
import { computed } from 'vue';
import { format, parseISO, isFuture, isToday } from 'date-fns';
import { pl } from 'date-fns/locale';

const props = defineProps({
  group: {
    type: Object,
    required: true
  }
});

const dayNames = ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"];

const upcomingHours = computed(() => {
  if (!props.group || !props.group.hours) {
    return [];
  }
  const today = new Date();
  return props.group.hours.filter(hour => {
    const startDate = parseISO(hour.start_date);
    return isFuture(startDate) || isToday(startDate);
  }).sort((a, b) => parseISO(a.start_date) - parseISO(b.start_date));
});

const formatHour = (hour) => {
  const startDate = parseISO(hour.start_date);
  const dayName = dayNames[hour.day_of_week];
  
  // Using date-fns for formatting which is more robust
  const dateStr = format(startDate, "d MMMM yyyy", { locale: pl });

  return `<strong>${dateStr}</strong>,<br>${dayName} ${hour.hour_start}-${hour.hour_end}`;
};
</script>

<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}
li {
  background-color: #f9f9f9;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  border-radius: 4px;
}
</style>
